import { axiosInstance } from './api';

export default {
  createSensorAlarm: alarmInfo => axiosInstance.post('/sensor', alarmInfo),
  getSensors: () => axiosInstance.get('/sensor'),
  getSensorById: id => axiosInstance.get(`/sensor/${id}`),
  deleteSensor: data => axiosInstance.delete(`/sensor/${data.id}`),
  updateSensor: ({ id, data }) => axiosInstance.put(`/sensor/${id}`, data)
};
